import { render, staticRenderFns } from "./TpdParticipationProcessList.vue?vue&type=template&id=792f0ed8&"
import script from "./TpdParticipationProcessList.vue?vue&type=script&lang=js&"
export * from "./TpdParticipationProcessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports